<template>
    <div class="ph3 pageFont pv4">

        <div class="pb4">Sorry, no results were found for <b>{{search}}</b></div>

        <!-- searches list -->
        <ItemList @click="keywordSearch($event.item)" class="mb2" :items="topSearches" title="Top Searches:"/>
    {{hello}}
        <!-- categories list -->
        <ItemList @click="categorySearch($event.id)" class="mt4 mb2" :items="topCategories" title="Top Categories:"/>

    </div>
</template>

<script>
import ItemList from '@/components/search/noResults/ItemList.vue';

export default {
    data() {
        return {
            hello: null,
            search: this.$route.query.q,
            topSearches: [
                { item: 'Drill' },
                { item: 'pressure washer' },
                { item: 'generator' },
                { item: 'trencher' },
                { item: 'extension ladder' }
            ],
            topCategories: [
                {
                    item: 'Drill',
                    id: 12
                },
                {
                    item: 'Nailer',
                    id: 16
                },
                {
                    item: 'Scaffolding',
                    id: 211
                },
                {
                    item: 'Grinder',
                    id: 14
                },
                {
                    item: 'Balloon Lights',
                    id: 134
                }
            ]
        };
    },
    components: {
        ItemList
    },
    methods: {
        keywordSearch(word) {
            this.$router.push({ path: '/search', query: { q: word } });
        },
        categorySearch(categoryId) {
            this.$router.push({
                path: '/search',
                query: { category: categoryId }
            });
        }
    }
};
</script>

<style scoped>
.pageFont {
    font-size: 20px;
}
</style>
